// AUTO-GENERATED FILE - DO NOT EDIT
// This file was automatically generated by the XDK build tool.
// Any manual changes will be overwritten on the next generation.
/**
 * X API SDK
 *
 * A modern TypeScript/JavaScript SDK for interacting with the X API.
 * Built with full TypeScript support, React hooks, and Next.js integration.
 */

// Automatic polyfill setup for Node.js environments
if (typeof process !== 'undefined' && process.versions && process.versions.node) {
  // Node.js environment - set up polyfills if needed
  if (typeof globalThis.fetch === 'undefined' || typeof globalThis.Headers === 'undefined') {
    try {
      // Try to use native Node.js fetch (Node 18+)
      if (typeof globalThis.fetch === 'function' && typeof globalThis.Headers === 'function') {
        // Native APIs are available, no polyfills needed
      } else {
        // Need to set up polyfills for older Node.js versions
        const nodeFetch = require('node-fetch');
        const { Headers: NodeHeaders } = nodeFetch;
        
        if (typeof globalThis.fetch === 'undefined') {
          (globalThis as any).fetch = nodeFetch.default || nodeFetch;
        }
        if (typeof globalThis.Headers === 'undefined') {
          (globalThis as any).Headers = NodeHeaders;
        }
      }
    } catch (error) {
      // If node-fetch is not available, provide a helpful error
      console.warn(
        'X API SDK: node-fetch not found. For Node.js environments, please install node-fetch:\n' +
        'npm install node-fetch\n' +
        'Or upgrade to Node.js 18+ for native fetch support.'
      );
    }
  }
}

// Main client
export { Client } from './client.js';
export type { ClientConfig } from './client.js';

// Error handling
export { ApiError } from './client.js';
export type { RequestOptions, ApiResponse, PaginationMeta } from './client.js';

// HTTP client
export { httpClient, HttpClient } from './http-client.js';
export type { RequestOptions as HttpClientRequestOptions, HttpResponse } from './http-client.js';

// Authentication
export { OAuth2 } from './oauth2_auth.js';
export type { OAuth2Config, OAuth2Token } from './oauth2_auth.js';
export { OAuth1 } from './oauth1_auth.js';
export type { OAuth1Config, OAuth1RequestToken, OAuth1AccessToken } from './oauth1_auth.js';

// Crypto utilities
export { CryptoUtils, hmacSha1, generateNonce, generateTimestamp, generateCodeVerifier, generateCodeChallenge } from './crypto_utils.js';

// Streaming
export type { StreamListener, TweetStreamListener } from './stream_listener.js';

// Schema types (export all OpenAPI schema types)
export * as Schemas from './schemas.js';

// Client modules (export client classes and types)

export { UsersClient } from './users/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as Users from './users/models.js';

export { StreamClient } from './stream/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as Stream from './stream/models.js';

export { ConnectionsClient } from './connections/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as Connections from './connections/models.js';

export { CommunitiesClient } from './communities/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as Communities from './communities/models.js';

export { CommunityNotesClient } from './community_notes/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as CommunityNotes from './community_notes/models.js';

export { TrendsClient } from './trends/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as Trends from './trends/models.js';

export { ListsClient } from './lists/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as Lists from './lists/models.js';

export { GeneralClient } from './general/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as General from './general/models.js';

export { DirectMessagesClient } from './direct_messages/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as DirectMessages from './direct_messages/models.js';

export { ActivityClient } from './activity/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as Activity from './activity/models.js';

export { UsageClient } from './usage/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as Usage from './usage/models.js';

export { WebhooksClient } from './webhooks/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as Webhooks from './webhooks/models.js';

export { AccountActivityClient } from './account_activity/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as AccountActivity from './account_activity/models.js';

export { NewsClient } from './news/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as News from './news/models.js';

export { SpacesClient } from './spaces/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as Spaces from './spaces/models.js';

export { PostsClient } from './posts/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as Posts from './posts/models.js';

export { MediaClient } from './media/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as Media from './media/models.js';

export { ComplianceClient } from './compliance/client.js';
// Export all types (Request, Response, Options) from this module as a namespace
export * as Compliance from './compliance/models.js';


// Utilities
export * from './paginator.js'; 